import { Typography } from "@mui/material";
import React from "react";
export default function LinearGoldText({
  isMobile,
  style,
  children,
}: {
  isMobile: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}) {
  return (
    <Typography
      style={{
        fontSize: isMobile ? "16px" : "24px",
        fontWeight: "500",
        color: "#FDE18B",

        backgroundImage:
          "linear-gradient(90deg, #FDE18B 10.66%, #ECB965 39.59%, #F8F4EE 66.69%, #C4913C 100%)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        textAlign: "left",
        ...style,
      }}
    >
      {children}
    </Typography>
  );
}
